import React from 'react';
import { useUnit } from '../../context/UnitContext';
import './DailyConsumptionCard.css';

/**
 * Un día dentro de la lista del historial.
 *
 * Es un selector, no una ficha: su trabajo es dejar elegir el día cuyo desglose
 * horario se pinta al lado. Por eso ahora es una fila y no una tarjeta con dos
 * cajas anidadas dentro; en la altura donde antes cabían tres días caben diez,
 * que es lo que hace usable una lista de treinta.
 *
 * Los caudales sólo aparecen en el día seleccionado: en los otros veintinueve
 * eran ruido que nadie estaba leyendo.
 */
function DailyConsumptionCard({
  date,
  dateLabel,
  consumption,
  maxFlowRate,
  avgFlowRate,
  isSelected,
  onClick,
}) {
  const { formatValueWithUnit } = useUnit();

  // Validar que los valores numéricos sean válidos
  const safeMaxFlowRate = (maxFlowRate !== undefined && !isNaN(maxFlowRate)) ? maxFlowRate : 0;
  const safeAvgFlowRate = (avgFlowRate !== undefined && !isNaN(avgFlowRate)) ? avgFlowRate : 0;

  /* `new Date("2026-04-29")` se interpreta como medianoche UTC, que en México
     es el 28 por la tarde: la fila mostraba "miércoles, 29 de abril" encima de
     "28/04/2026". Se construye la fecha por partes, en hora local, igual que
     hace `formatDate` en la pantalla del historial. */
  const [year, month, day] = String(date).split('-').map(Number);
  const shortDate = new Date(year, month - 1, day).toLocaleDateString('es-MX', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });

  return (
    <button
      type="button"
      className={`daily-consumption-card ${isSelected ? 'selected' : ''}`}
      onClick={onClick}
      aria-pressed={isSelected}
    >
      <span className="card-date">
        <span className="date-label">{dateLabel}</span>
        <span className="date-value">{shortDate}</span>
      </span>

      <span className="card-consumption">{formatValueWithUnit(consumption)}</span>

      {isSelected && (
        <span className="card-details">
          Caudal máximo {safeMaxFlowRate.toFixed(2)} L/min · promedio{' '}
          {safeAvgFlowRate.toFixed(2)} L/min
        </span>
      )}
    </button>
  );
}

export default DailyConsumptionCard;
